module.exports = __webpack_public_path__ + "static/media/no-img.decb60bc.webp";